var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ProductDescription"},[(_vm.productDescription)?_c('div',{staticClass:"ProductDescription-text"},[_c('Richtext',{attrs:{"text":_vm.productDescription}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }